export default class DashboardEvent {
    constructor(type) {
        this.type = type;
    }
}

DashboardEvent.OPEN_SCREEN_REQUEST = "DashboardEvent.OPEN_SCREEN_REQUEST";
DashboardEvent.CLOSE_SCREEN_REQUEST = "DashboardEvent.CLOSE_SCREEN_REQUEST";
DashboardEvent.GOTO_SCREEN_REQUEST = "DashboardEvent.GOTO_SCREEN_REQUEST";
DashboardEvent.ENABLE_DASHBOARD_BUTTON = "DashboardEvent.ENABLE_DASHBOARD_BUTTON";
DashboardEvent.DISABLE_DASHBOARD_BUTTON = "DashboardEvent.DISABLE_DASHBOARD_BUTTON";